import { default as _91id_937BiJLE0qzoMeta } from "/Users/khulan/projects/bolorsoft/eduge-input-man/frontend/pages/crawlerrors/[id].vue?macro=true";
import { default as index2sceU7vR5sMeta } from "/Users/khulan/projects/bolorsoft/eduge-input-man/frontend/pages/crawlerrors/index.vue?macro=true";
import { default as _91id_935wsoWKnJY3Meta } from "/Users/khulan/projects/bolorsoft/eduge-input-man/frontend/pages/credentials/[id].vue?macro=true";
import { default as indexQsAhkIWtzDMeta } from "/Users/khulan/projects/bolorsoft/eduge-input-man/frontend/pages/credentials/index.vue?macro=true";
import { default as customers1TrQJmKAMxMeta } from "/Users/khulan/projects/bolorsoft/eduge-input-man/frontend/pages/customers.vue?macro=true";
import { default as index2sDEBZqa8yMeta } from "/Users/khulan/projects/bolorsoft/eduge-input-man/frontend/pages/index.vue?macro=true";
import { default as itemsWnIaaQFUDNMeta } from "/Users/khulan/projects/bolorsoft/eduge-input-man/frontend/pages/items.vue?macro=true";
import { default as loginNKz05EEkb5Meta } from "/Users/khulan/projects/bolorsoft/eduge-input-man/frontend/pages/login.vue?macro=true";
import { default as sources_45reviewHfKKVuYB3qMeta } from "/Users/khulan/projects/bolorsoft/eduge-input-man/frontend/pages/sources-review.vue?macro=true";
import { default as _91channel_93hAkBJTTXNIMeta } from "/Users/khulan/projects/bolorsoft/eduge-input-man/frontend/pages/sources/[channel].vue?macro=true";
import { default as indexMp2ALvHASXMeta } from "/Users/khulan/projects/bolorsoft/eduge-input-man/frontend/pages/tasks/index.vue?macro=true";
import { default as indexJLageqNjZNMeta } from "/Users/khulan/projects/bolorsoft/eduge-input-man/frontend/pages/topics/index.vue?macro=true";
export default [
  {
    name: _91id_937BiJLE0qzoMeta?.name ?? "crawlerrors-id",
    path: _91id_937BiJLE0qzoMeta?.path ?? "/crawlerrors/:id()",
    meta: _91id_937BiJLE0qzoMeta || {},
    alias: _91id_937BiJLE0qzoMeta?.alias || [],
    redirect: _91id_937BiJLE0qzoMeta?.redirect || undefined,
    component: () => import("/Users/khulan/projects/bolorsoft/eduge-input-man/frontend/pages/crawlerrors/[id].vue").then(m => m.default || m)
  },
  {
    name: index2sceU7vR5sMeta?.name ?? "crawlerrors",
    path: index2sceU7vR5sMeta?.path ?? "/crawlerrors",
    meta: index2sceU7vR5sMeta || {},
    alias: index2sceU7vR5sMeta?.alias || [],
    redirect: index2sceU7vR5sMeta?.redirect || undefined,
    component: () => import("/Users/khulan/projects/bolorsoft/eduge-input-man/frontend/pages/crawlerrors/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_935wsoWKnJY3Meta?.name ?? "credentials-id",
    path: _91id_935wsoWKnJY3Meta?.path ?? "/credentials/:id()",
    meta: _91id_935wsoWKnJY3Meta || {},
    alias: _91id_935wsoWKnJY3Meta?.alias || [],
    redirect: _91id_935wsoWKnJY3Meta?.redirect || undefined,
    component: () => import("/Users/khulan/projects/bolorsoft/eduge-input-man/frontend/pages/credentials/[id].vue").then(m => m.default || m)
  },
  {
    name: indexQsAhkIWtzDMeta?.name ?? "credentials",
    path: indexQsAhkIWtzDMeta?.path ?? "/credentials",
    meta: indexQsAhkIWtzDMeta || {},
    alias: indexQsAhkIWtzDMeta?.alias || [],
    redirect: indexQsAhkIWtzDMeta?.redirect || undefined,
    component: () => import("/Users/khulan/projects/bolorsoft/eduge-input-man/frontend/pages/credentials/index.vue").then(m => m.default || m)
  },
  {
    name: customers1TrQJmKAMxMeta?.name ?? "customers",
    path: customers1TrQJmKAMxMeta?.path ?? "/customers",
    meta: customers1TrQJmKAMxMeta || {},
    alias: customers1TrQJmKAMxMeta?.alias || [],
    redirect: customers1TrQJmKAMxMeta?.redirect || undefined,
    component: () => import("/Users/khulan/projects/bolorsoft/eduge-input-man/frontend/pages/customers.vue").then(m => m.default || m)
  },
  {
    name: index2sDEBZqa8yMeta?.name ?? "index",
    path: index2sDEBZqa8yMeta?.path ?? "/",
    meta: index2sDEBZqa8yMeta || {},
    alias: index2sDEBZqa8yMeta?.alias || [],
    redirect: index2sDEBZqa8yMeta?.redirect || undefined,
    component: () => import("/Users/khulan/projects/bolorsoft/eduge-input-man/frontend/pages/index.vue").then(m => m.default || m)
  },
  {
    name: itemsWnIaaQFUDNMeta?.name ?? "items",
    path: itemsWnIaaQFUDNMeta?.path ?? "/items",
    meta: itemsWnIaaQFUDNMeta || {},
    alias: itemsWnIaaQFUDNMeta?.alias || [],
    redirect: itemsWnIaaQFUDNMeta?.redirect || undefined,
    component: () => import("/Users/khulan/projects/bolorsoft/eduge-input-man/frontend/pages/items.vue").then(m => m.default || m)
  },
  {
    name: loginNKz05EEkb5Meta?.name ?? "login",
    path: loginNKz05EEkb5Meta?.path ?? "/login",
    meta: loginNKz05EEkb5Meta || {},
    alias: loginNKz05EEkb5Meta?.alias || [],
    redirect: loginNKz05EEkb5Meta?.redirect || undefined,
    component: () => import("/Users/khulan/projects/bolorsoft/eduge-input-man/frontend/pages/login.vue").then(m => m.default || m)
  },
  {
    name: sources_45reviewHfKKVuYB3qMeta?.name ?? "sources-review",
    path: sources_45reviewHfKKVuYB3qMeta?.path ?? "/sources-review",
    meta: sources_45reviewHfKKVuYB3qMeta || {},
    alias: sources_45reviewHfKKVuYB3qMeta?.alias || [],
    redirect: sources_45reviewHfKKVuYB3qMeta?.redirect || undefined,
    component: () => import("/Users/khulan/projects/bolorsoft/eduge-input-man/frontend/pages/sources-review.vue").then(m => m.default || m)
  },
  {
    name: _91channel_93hAkBJTTXNIMeta?.name ?? "sources-channel",
    path: _91channel_93hAkBJTTXNIMeta?.path ?? "/sources/:channel()",
    meta: _91channel_93hAkBJTTXNIMeta || {},
    alias: _91channel_93hAkBJTTXNIMeta?.alias || [],
    redirect: _91channel_93hAkBJTTXNIMeta?.redirect || undefined,
    component: () => import("/Users/khulan/projects/bolorsoft/eduge-input-man/frontend/pages/sources/[channel].vue").then(m => m.default || m)
  },
  {
    name: indexMp2ALvHASXMeta?.name ?? "tasks",
    path: indexMp2ALvHASXMeta?.path ?? "/tasks",
    meta: indexMp2ALvHASXMeta || {},
    alias: indexMp2ALvHASXMeta?.alias || [],
    redirect: indexMp2ALvHASXMeta?.redirect || undefined,
    component: () => import("/Users/khulan/projects/bolorsoft/eduge-input-man/frontend/pages/tasks/index.vue").then(m => m.default || m)
  },
  {
    name: indexJLageqNjZNMeta?.name ?? "topics",
    path: indexJLageqNjZNMeta?.path ?? "/topics",
    meta: indexJLageqNjZNMeta || {},
    alias: indexJLageqNjZNMeta?.alias || [],
    redirect: indexJLageqNjZNMeta?.redirect || undefined,
    component: () => import("/Users/khulan/projects/bolorsoft/eduge-input-man/frontend/pages/topics/index.vue").then(m => m.default || m)
  }
]